// Compatibility shim for mobile apps
window.Turbolinks = {
  visit: Turbo.visit,

  controller: {
    isDeprecatedAdapter(adapter) {
      return typeof adapter.visitProposedToLocation !== "function";
    },

    startVisitToLocationWithAction(location, action, restorationIdentifier) {
      window.Turbo.navigator.startVisit(location, restorationIdentifier, {
        action,
      });
    },

    get restorationIdentifier() {
      return window.Turbo.navigator.restorationIdentifier;
    },

    get adapter() {
      return window.Turbo.navigator.adapter;
    },

    set adapter(adapter) {
      if (this.isDeprecatedAdapter(adapter)) {
        // Old mobile adapters do not support visitProposedToLocation()
        adapter.visitProposedToLocation = function (location, options) {
          adapter.visitProposedToLocationWithAction(location, options.action);
        };

        // Old mobile adapters use visit.location.absoluteURL, which is not available
        // because Turbo dropped the Location class in favor of the DOM URL API
        const adapterVisitStarted = adapter.visitStarted;
        adapter.visitStarted = function (visit) {
          Object.defineProperties(visit.location, {
            absoluteURL: {
              configurable: true,
              get() {
                return this.toString();
              },
            },
          });

          adapter.currentVisit = visit;
          adapterVisitStarted(visit);
        };
      }

      window.Turbo.registerAdapter(adapter);
    },
  },
};

// Required by the desktop app
document.addEventListener("turbo:load", function () {
  const event = new CustomEvent("turbolinks:load", { bubbles: true });
  document.documentElement.dispatchEvent(event);
});
